import InternshipLetter from "./Exits/InternshipLetter";
import EmployeeDetails from "./pre-onboardig/EmployeeDetails";
import PreOnboardingDashboard from "./pre-onboardig/tabs/Dashboard/Dashboard";
import EmployeeAccountsManagement from "./SalaryManagement/EmployeeAccountsManagement";
import SalaryManagement from "./SalaryManagement/SalaryManagement";
import HRAnalytics from "./targets/BDE/BDEAnalyticsDashboard";
import SetHRATargets from "./targets/HR/SetHRATargets";
import BDEAnalytics from "./targets/HR/Analytics";
import SetBDETargets from "./targets/BDE/SetBDETargets";
import CodingQuestions from "./TestSetup/CodingQuestions";
import TestDashboard from "./TestSetup/Dashboard";
import MCQQuestions from "./TestSetup/MCQQuestions";
import TestSetup from "./TestSetup/TestSetup";
import AIInterviewQuestions from "./TestSetup/AIInterviewQuestions";
import BDEAnalyticsDashboard from "./targets/BDE/BDEAnalyticsDashboard";
import Acceptance from "./pre-onboardig/onboarding/offers/Acceptance";
import Approval from "./pre-onboardig/onboarding/offers/Approval";
import Hired from "./pre-onboardig/onboarding/offers/Hired";
import ReleaseOffer from "./pre-onboardig/onboarding/offers/ReleaseOffer";
import ActivityLog from "./targets/BDE/components/bdetracker/activitylog/ActivityLog";
import WorkLog from "./targets/BDE/components/bdetracker/work-log/WorkLog";

export const HRMRoutes = {
    PreOnboardingDashboard,
    EmployeeDetails,
    TestDashboard,
    CodingQuestions,
    MCQQuestions,
    TestSetup,
    AIInterviewQuestions,
    InternshipLetter,
    SalaryManagement,
    EmployeeAccountsManagement,
    HRAnalytics,
    BDEAnalyticsDashboard,
    SetHRATargets,
    SetBDETargets,
    Acceptance,
    Approval,
    Hired,
    ReleaseOffer,
    ActivityLog,
    WorkLog,
}